import { apiRequest, handleCall } from 'syft-acp-core/api/call'
import { Query } from './types'

export const fetchAgencyShiftHistory = ({ payload }: { payload: Query }) =>
    new Promise((resolve, reject) => { const req = apiRequest({
        path: `/admin/agency_shift_history`, reqArgs: payload
    })
    handleCall(req, resolve, reject, true, payload)
  })
